// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostProfileActionsWidget-moduleNewsboardPostProfileActionsWidget__zE8Lt Widget-moduleWidget__bcnWB";
export { _1 as "NewsboardPostProfileActionsWidget" }
